import { render, staticRenderFns } from "./apiUrl.vue?vue&type=template&id=8f11ecc8&scoped=true&"
import script from "./apiUrl.vue?vue&type=script&lang=js&"
export * from "./apiUrl.vue?vue&type=script&lang=js&"
import style0 from "./apiUrl.vue?vue&type=style&index=0&id=8f11ecc8&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8f11ecc8",
  null
  
)

export default component.exports